import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';

// shortcut: dev-only, defers RO callbacks one frame so react-aria popovers don't trip the
// "ResizeObserver loop" error into the dev-server overlay; remove if Backstage CLI exposes overlay.runtimeErrors.
if (process.env.NODE_ENV === 'development') {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) =>
        requestAnimationFrame(() => callback(entries, observer)),
      );
    }
  };
}

ReactDOM.createRoot(document.getElementById('root')!).render(App);
